import isValidPhoneNumber from '@/utils/isValidPhoneNumber';
import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';

export const schema = GetPatientDetailsSchema.shape.emergencyContact
  .unwrap()
  .shape.attributes.pick({
    firstName: true,
    lastName: true,
    phoneNumber: true,
    relationship: true
  })
  .partial()
  .refine(
    (data) => {
      if (!data.phoneNumber) {
        return true;
      }
      return (data.phoneNumber || '').length === 0 || isValidPhoneNumber(data.phoneNumber || '');
    },
    {
      message: 'Invalid phone number',
      path: ['phoneNumber']
    }
  );
